export default {"src":"/_next/static/media/Building.d5715464.svg","height":95,"width":182,"blurWidth":0,"blurHeight":0};